import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { PROMO } from '../../../brands/default/content/components/checkout';
import ThemeContext from '../../../providers/ThemeProvider';
import CTAButton from '../../_generic/button/CTAButton';
import InputForm from '../../_generic/input/Input';

const Promo = ({
  extraClasses,
  handlePromoClick,
  handleRemovePromoClick,
  hasError,
  errorMsg,
  isDisabled,
  isValidPromo,
  isAuthenticated,
  validMsg,
  validCode,
  showInput,
}) => {
  const theme = useContext(ThemeContext);
  const [hasInput, setHasInput] = useState(showInput);
  const [code, setCode] = useState('');
  const [validation, setValidation] = useState(false);

  const setPromoCode = (event) => {
    setValidation(true);
    setCode(event.target.value);
  };

  const togglePromo = (event) => {
    event.preventDefault();
    setHasInput(!hasInput);
  };

  const setInputState = () => {
    setValidation(hasError);
  };

  const checkError = () => {
    if (validation && code.length > 0) {
      return false;
    }

    return hasError;
  };

  const checkValue = () => {
    return isValidPromo ? validCode : code;
  };

  return (
    <div className={classNames('promo', extraClasses)}>
      {!hasInput && (
        <button className="promo__link" onClick={togglePromo} type="button">
          {PROMO.add}
        </button>
      )}
      {hasInput && (
        <div
          className={classNames('promo__form', {
            'promo__hide-error-msg': hasError && validation,
          })}
        >
          <InputForm
            bottomLined={Boolean(code.length > 0 && validation)}
            disable={isDisabled}
            error={checkError()}
            errorText={errorMsg}
            extraClasses="promo__input"
            inputValue={checkValue()}
            name={'redeem'}
            onChangeFunction={setPromoCode}
            onFocusFunction={setInputState}
            placeholder={PROMO.placeholder}
            type="text"
            valid={code.length > 0}
          />
          {!isValidPromo && (
            <CTAButton
              className="promo__btn"
              disabled={isDisabled}
              onClick={(event) => {
                setValidation(false);
                setCode('');
                handlePromoClick(event, code);
              }}
            >
              {PROMO.apply}
            </CTAButton>
          )}
          {isValidPromo && (
            <CTAButton
              className="promo__btn"
              onClick={(event) => {
                setValidation(false);
                handleRemovePromoClick(event, code);
              }}
            >
              {PROMO.remove}
            </CTAButton>
          )}
        </div>
      )}
      {!isAuthenticated && hasInput && (
        <p className="promo__log-in">{PROMO.notAuthenticated}</p>
      )}
      {isValidPromo && <p>{validMsg}</p>}
      <style jsx>{`
        .promo__form {
          display: flex;
          align-items: flex-start;
        }
        .promo__form :global(.promo__input) {
          flex-grow: 1;
          margin-right: 10px;
        }
        .promo__form :global(.promo__btn) {
          width: 104px;
        }
        .promo__form :global(.bg-danger) {
          background: none;
          color: #eb3f3c;
          padding-left: 0;
        }
        .promo__form.promo__hide-error-msg :global(.bg-danger) {
          display: none;
        }
        .promo__form :global(.form-control:disabled) {
          opacity: 0.4;
          background: #fff;
        }
        .promo__form :global(.form-control:disabled:hover) {
          cursor: no-drop;
        }
        .promo__link {
          display: block;
          color: ${theme.colors.primary};
          margin-bottom: 10px;
          background: none;
          cursor: pointer;
          border: none;
          padding: 0;
        }
        .promo__link:hover {
          cursor: pointer;
          color: #23527c;
        }
        .promo__log-in {
          color: #eb3f3c;
        }
      `}</style>
    </div>
  );
};

Promo.propTypes = {
  errorMsg: PropTypes.string,
  extraClasses: PropTypes.string,
  handlePromoClick: PropTypes.func,
  handleRemovePromoClick: PropTypes.func,
  hasError: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isValidPromo: PropTypes.bool,
  showInput: PropTypes.bool,
  validCode: PropTypes.string,
  validMsg: PropTypes.string,
};

Promo.defaultProps = {
  handlePromoClick: () => {},
  handleRemovePromoClick: () => {},
};
export default Promo;
